export const FRUSTUM_MESH_TYPE = 'frustumMesh';
/** Frustum geometry rendered for other panes (sync); distinct from {@link FRUSTUM_MESH_TYPE}. */
export const EXTERNAL_FRUSTUM_MESH_TYPE = 'externalFrustumMesh';
export const STATION_MARKER_MESH_TYPE = 'stationMarkerMesh';
export const STATION_PATH_MESH_TYPE = 'stationPathMesh';

export type MeshType =
  | typeof FRUSTUM_MESH_TYPE
  | typeof EXTERNAL_FRUSTUM_MESH_TYPE
  | typeof STATION_MARKER_MESH_TYPE
  | typeof STATION_PATH_MESH_TYPE;
